import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "D24Form" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_4 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_5 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_6 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_7 = { class: "flex items-center justify-between mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Подпись согл и основных", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_10 = { class: "flex items-center mb-2 w-1/2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-red-500" }, null, -1)
const _hoisted_12 = { class: "flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Отправить в Д24" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        disabled: _ctx.state.is_loading,
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_select, {
          placeholder: "Компания",
          loading: _ctx.data_state.companies.is_loading,
          failed: _ctx.data_state.companies.is_failed,
          "error-text": "При получении списка компаний произошла ошибка",
          options: _ctx.data_state.companies.list,
          value: _ctx.state.companyId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.companyId) = $event)),
          "is-invalid": _ctx.state_form$.companyId.$error,
          "validation-errors": _ctx.state_form$.companyId.$errors,
          "infinite-scroll": "",
          "search-without-refresh": "",
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
          onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
          onSearch: _ctx.searchCompanies,
          onOptionBySearch: _ctx.unshiftFindedCompany,
          class: "h-full"
        }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          placeholder: "Тип договора",
          loading: _ctx.data_state.types.is_loading,
          failed: _ctx.data_state.types.is_failed,
          "error-text": "При получении списка типов произошла ошибка",
          "is-invalid": _ctx.state_form$.typeId.$error,
          "validation-errors": _ctx.state_form$.typeId.$errors,
          options: _ctx.data_state.types.list,
          value: _ctx.state.typeId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.typeId) = $event)),
          "infinite-scroll": "",
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
          onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1))),
          class: "h-full"
        }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]),
        _createVNode(_component_the_select, {
          placeholder: "Подразделение",
          loading: _ctx.data_state.subdivisions.is_loading,
          failed: _ctx.data_state.subdivisions.is_failed,
          "error-text": "При получении списка подразделений произошла ошибка",
          options: _ctx.data_state.subdivisions.list,
          "is-invalid": _ctx.state_form$.subdivisionId.$error,
          "validation-errors": _ctx.state_form$.subdivisionId.$errors,
          value: _ctx.state.subdivisionId,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
          onRefresh: _ctx.loadSubdivisions,
          onChange: _ctx.onSubdivisionSelected,
          class: "h-full"
        }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
        _createVNode(_component_file_reader, {
          placeholder: "Загрузить файл",
          accept: "application/msword,application/pdf",
          value: _ctx.state.document,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.document) = $event)),
          class: "h-full"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер договора",
          value: _ctx.state.number,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.number) = $event)),
          "is-invalid": _ctx.state_form$.number.$error,
          "validation-errors": _ctx.state_form$.number.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_the_button, {
          class: "primary text small",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.addSigner
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.signers, (signer, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `signer-${idx}`,
          class: "flex justify-between"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_the_input, {
              placeholder: "Почта",
              "is-invalid": 
                            _ctx.state_form$.signers.$each?.$response?.$data[idx]?.email?.$invalid
                        ,
              value: _ctx.state.signers[idx].email,
              "onUpdate:value": ($event: any) => ((_ctx.state.signers[idx].email) = $event)
            }, null, 8, ["is-invalid", "value", "onUpdate:value"]),
            _createVNode(_component_the_select, {
              placeholder: "Тип подписи",
              class: "ml-3 mt-2 w-full",
              options: _ctx.D24_TYPES,
              "is-invalid": 
                            _ctx.state_form$.signers.$each?.$response?.$data[idx]?.dogovor24Type
                                ?.$invalid
                        ,
              value: _ctx.state.signers[idx].dogovor24Type,
              "onUpdate:value": ($event: any) => ((_ctx.state.signers[idx].dogovor24Type) = $event)
            }, null, 8, ["options", "is-invalid", "value", "onUpdate:value"])
          ]),
          _createVNode(_component_the_button, {
            class: "text small",
            onClick: ($event: any) => (_ctx.deleteItem(idx))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.state.is_loading,
          onClick: _ctx.sendD24
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Отправить в Д24 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}